package pl.decks.personal.components.widgets.hasdiagram

sealed class HASDiagramException(msg: String) : IllegalStateException(msg) {
    class DuplicateHASNodePositionException(position: HASNodePosition) : HASDiagramException(
        "HubAndSpokeDiagram: Node already declared for position: $position",
    )
    class HASNodePositionOutOfRangeException(position: Int, fixedPositions: Int) : HASDiagramException(
        "Outer($position) is out of range " +
                "— diagram has fixed number = $fixedPositions of outer slots (0..${fixedPositions - 1})"
    )
}
